import { createFileRoute, redirect } from '@tanstack/react-router'
import { authClient } from '#lib/auth'
import { LoginPage } from '#pages/auth/LoginPage'

export const Route = createFileRoute('/login')({
  beforeLoad: async () => {
    const { data } = await authClient.getSession()
    if (data?.user) throw redirect({ to: '/' })
  },
  component: LoginPage,
})
